export default function Footer() {
  return (
    <footer className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-10 md:py-12">
        <div className="flex flex-col justify-between gap-8 sm:flex-row">
          <div className="max-w-sm">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-24-hours-fill text-base" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-base font-bold tracking-tight text-foreground-950">
                扒哥黑料
              </span>
            </a>
            <p className="mt-3 text-sm leading-6 text-foreground-500">
              实锤锤文、证据链截图与时间轴推理全公开。吃瓜也讲证据，先核对，再下结论。
            </p>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-2">
            {[
              { href: "#hammer", label: "今日在锤" },
              { href: "#archive", label: "合集索引" },
              { href: "#chain", label: "证据链" },
              { href: "#timeline", label: "时间轴" },
              { href: "#heat", label: "热度榜" },
              { href: "#note", label: "编辑声明" },
            ].map((it) => (
              <a
                key={it.href}
                href={it.href}
                className="cursor-pointer whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                {it.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-8 flex flex-col gap-2 border-t border-background-200 pt-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-400">
            © {new Date().getFullYear()} 扒哥黑料 · 本站为公开信息整理与推理，页面人物均以化名代号呈现。
          </p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-shield-check-line" aria-hidden="true"></i>
            理性吃瓜 · 证据优先
          </p>
        </div>
      </div>
    </footer>
  );
}